import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Bell } from "lucide-react";
import api from "@/lib/api";

export default function PortalNotifications() {
  const qc = useQueryClient();
  const { data: items = [] } = useQuery({ queryKey: ["portal-notifications"], queryFn: async () => (await api.get("/portal/notifications")).data });

  const markRead = async (id) => {
    await api.post(`/portal/notifications/${id}/read`);
    qc.invalidateQueries({ queryKey: ["portal-notifications"] });
    qc.invalidateQueries({ queryKey: ["portal-dashboard"] });
  };

  return (
    <div>
      <h1 className="font-display text-2xl font-bold">Notifications</h1>
      <div className="mt-6 space-y-3">
        {items.length === 0 && <p className="rounded-xl border border-dashed border-border p-8 text-center text-sm text-muted-foreground">You're all caught up.</p>}
        {items.map((n) => (
          <button key={n.id} onClick={() => markRead(n.id)}
            className={`flex w-full items-start gap-3 rounded-xl border border-border p-4 text-left transition-colors hover:bg-secondary ${n.read ? "opacity-60" : "bg-card"}`}>
            <div className="rounded-lg bg-primary/12 p-2 text-primary"><Bell className="h-4 w-4" /></div>
            <div className="flex-1">
              <p className="text-sm font-semibold">{n.title}</p>
              <p className="text-sm text-muted-foreground">{n.body}</p>
              <p className="mt-1 text-[11px] text-muted-foreground">{new Date(n.created_at).toLocaleString()}</p>
            </div>
            {!n.read && <span className="mt-1 h-2 w-2 rounded-full bg-primary" />}
          </button>
        ))}
      </div>
    </div>
  );
}
